export default "__VITE_ASSET__DXnxNUz6__"